import React from "react";
import { Section, type SectionProps } from "components/section";
import { TextTitle } from "ui/text";
import { horizontalContainerPadding } from "ui/container";
import { CenteredSlider } from "./slider";
import { SliderCard, type SliderCardProps } from "./slider-card";

type CaseStudySliderProps = {
  title: string;
  slides: SliderCardProps[];
} & SectionProps;

export function CaseStudySlider({ title, slides, ...sectionProps }: CaseStudySliderProps) {
  return (
    <Section fullWidth noContainerPx {...sectionProps}>
      <TextTitle
        align="center"
        mobileAlign="center"
        size="lg"
        title={title}
        mb="biggest"
        px={horizontalContainerPadding}
      />

      <CenteredSlider>
        {slides.map((slide) => (
          <SliderCard key={slide.title} {...slide} />
        ))}
      </CenteredSlider>
    </Section>
  );
}
